import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CheckSwitch from '@rad/components/inputs/checkswitch';
import { textClass } from './common';
const SmsConsent = ({ value, onChange, variant = 'default' }) => (_jsx("div", { className: "mb-3", children: _jsx(CheckSwitch, { switch: false, value: value, onChange: onChange, label: _jsx("span", { className: textClass(variant), children: "I consent to receive one-time passcodes (2FA) from 76UNBOXED. Message & data rates may apply. You can reply STOP to unsubscribe at any time." }) }) }));
export default SmsConsent;
